/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestnewlink2Inputs */

const en_requestnewlink2 = /** @type {(inputs: Requestnewlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a new link`)
};

const de_requestnewlink2 = /** @type {(inputs: Requestnewlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Link anfordern`)
};

/**
* | output |
* | --- |
* | "Request a new link" |
*
* @param {Requestnewlink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestnewlink2 = /** @type {((inputs?: Requestnewlink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestnewlink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestnewlink2(inputs)
	return de_requestnewlink2(inputs)
});
export { requestnewlink2 as "requestNewLink" }